
export const CompanyData={
    short_name:"Privazio",
    name: "Privazio",
    address: "",
    short_address: "",
    email: "hello@privaz.io",
    support_email: "support@privaz.io",
    phone: "",
    org_number: "",
    VAT: ""
};
